const UUID_V4_PATTERN = new RegExp(
  /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i
);

export const isUUID = (data) => UUID_V4_PATTERN.test(data);
